import {
  eachDayOfInterval,
  endOfMonth,
  isWeekend,
  startOfMonth,
} from "date-fns";
import type { ReactElement } from "react";
import ReactDOM from "react-dom";

export function valueOrNothing<T>(condition: boolean, value: T) {
  return condition ? value : undefined;
}

export function typedObjectKeys<T extends object>(obj: T): (keyof T)[] {
  return Object.keys(obj) as (keyof T)[];
}

export function generateRandomId() {
  return (Math.random() + 1).toString(36).substring(7);
}

export function throttle<T extends (...params: unknown[]) => void>(
  callback: T,
  delay = 250,
) {
  let shouldWait = false;
  let waitingArgs: Parameters<T> | null = null;
  const timeoutFunc = () => {
    if (waitingArgs == null) {
      shouldWait = false;
    } else {
      callback(...waitingArgs);
      waitingArgs = null;
      setTimeout(timeoutFunc, delay);
    }
  };

  return (...args: Parameters<T>) => {
    if (shouldWait) {
      waitingArgs = args;
      return;
    }

    callback(...args);
    shouldWait = true;
    setTimeout(timeoutFunc, delay);
  };
}

export const searchForElement = (className: string, order: number) => {
  const divs = document.querySelectorAll(className);

  return divs[order];
};

export const createSpaceForComponent = (newClassName: string) => {
  const newTarget = document.createElement("div");
  newTarget.classList.add(newClassName);

  return newTarget;
};

export const addNewComponent = (component: ReactElement, target: Element) => {
  if (!component) return;

  ReactDOM.render(component, target);

  return () => {
    ReactDOM.unmountComponentAtNode(target);
  };
};

export const getNbOfWorkingDaysPerMonth = (year: number, month: number) => {
  // Create the start and end of the month
  const start = new Date(`${year}-${month + 1}-01`);
  const end = endOfMonth(new Date(`${year}-${month + 1}-01`));

  // Get all days of the month
  const days = eachDayOfInterval({ start, end });

  // Count the days that are not weekends
  const weekdaysCount = days.filter((day) => !isWeekend(day)).length;

  return weekdaysCount;
};

export const getNbOfWeekendsPerMonth = (year: number, month: number) => {
  // Create the start and end of the month
  const start = startOfMonth(new Date(year, month - 1));
  const end = endOfMonth(new Date(year, month - 1));

  // Get all days of the month
  const days = eachDayOfInterval({ start, end });

  // Count the days that are weekends
  const weekendsCount = days.filter((day) => isWeekend(day)).length;

  return weekendsCount;
};
